import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VModal from 'vue-js-modal'
import feather from 'vue-icon'
import throttle from 'lodash/throttle'
import isMobile from 'is-mobile'
import 'leaflet/dist/leaflet.css';
import './assets/scss/index.scss'

Vue.config.productionTip = false

Vue.use(feather, 'v-icon')
Vue.use(VModal)

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');

// Исправления layout для мобильных устрйоств
if (isMobile()) {
    setCorrectHeightOnMount();
    // Throttled функция установки корректной высоты
    const throttledSetCorrectHeight = throttle(setCorrectHeightOnEvent, 50);
    window.addEventListener('resize', throttledSetCorrectHeight);
    window.addEventListener('scroll', throttledSetCorrectHeight);

    window.screen.orientation?.lock
    && window.screen.orientation?.lock('portrait').catch(new Function);
}

// Устанавливает корректную высоту контейнера приложения по viewport
// Необходимо для мобильных браузеров, где отображение верхней шторки меняется при скролле
function setCorrectHeightOnEvent() {
    const correctHeight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    document.querySelector('body')
        .style.setProperty('height', `${correctHeight}px`);
}

// Устанавливает корректную высоту контейнера приложения по viewport
// Необходимо для мобильных браузеров, где отображение верхней шторки меняется при скролле
function setCorrectHeightOnMount() {
    const correctHeight = Math.min(document.documentElement.clientHeight ?? window.innerHeight);
    document.querySelector('body')
        .style.setProperty('height', `${correctHeight}px`);
}
